import { mapState, mapActions } from "vuex";
import ExcelTemplateList from "@/components/setting/ExcelTemplateList.vue";
import Common from "@/libs/Common.js";

export default {
  name: "Setting",
  components: {
    ExcelTemplateList,
  },
  data() {
    return {      
      isEditable: true, // 편집 가능 여부
      showDiscountItems: false, // 할인 항목 표시 여부
      _preventWatchLoop: false, // 무한루프 방지 플래그
      settings: {
        settlementTiming: 'delivery_completed', // 정산시점 설정 (기본값: 구매확정일)
        discountApplyTiming: 'now',
        supplierBurden: false, // 공급사 부담 여부
        discountItems: [] // 할인 항목 배열
      },
      originalSettings: {} // 원본 설정값 저장용
    };
  },  
  watch: {
    // 공급사 부담 체크박스 변경 감지
    'settings.supplierBurden': {
      handler(newVal, oldVal) {
        console.log("=== supplierBurden watch 시작 ===");
        console.log("변경값:", newVal, "이전값:", oldVal);
        console.log("preventWatchLoop 상태:", this._preventWatchLoop);
        
        // 즉시 실행인 경우는 로그만 찍고 리턴
        if (oldVal === undefined) {
          console.log("watch 초기 실행 - 처리 건너뜀");
          return;
        }
        
        // 무한루프 방지 - 프로그래밍적 변경은 무시
        if (this._preventWatchLoop) {
          console.log("프로그래밍적 변경 감지 - watch 무시");
          return;
        }
        
        console.log("사용자 액션으로 인한 변경 처리");
        
        // 무한루프 방지 플래그 설정
        this._preventWatchLoop = true;
        
        if (newVal) {
          // 공급사 부담 체크 시: 모든 할인 항목 선택하고 레이어 열기
          console.log("공급사 부담 체크 - 모든 항목 선택 처리");
          this.settings.discountItems = ["benefit", "coupon", "discount_code"];
          this.showDiscountItems = true;
          
          // custom_select_box disabled 클래스 제거
          this.$nextTick(() => {
            const selectBox = document.querySelector('.custom_select_box');
            if (selectBox) {
              selectBox.classList.remove('disabled');
              console.log("watch에서 disabled 클래스 제거 완료");
              
              // 전체 선택 체크박스도 활성화
              const selectAllCheckbox = document.querySelector('.select-all-container input[type="checkbox"]');
              if (selectAllCheckbox) {
                selectAllCheckbox.disabled = false;
                console.log("watch에서 전체 선택 체크박스 활성화 완료");
              }
            }
          });
        } else {
          // 공급사 부담 해제 시: 모든 할인 항목 해제하고 레이어 닫기
          console.log("공급사 부담 해제 - 모든 항목 해제 처리");
          this.settings.discountItems = [];
          this.showDiscountItems = false;
          
          // custom_select_box disabled 클래스 추가
          this.$nextTick(() => {
            const selectBox = document.querySelector('.custom_select_box');
            if (selectBox) {
              selectBox.classList.add('disabled');
              console.log("watch에서 disabled 클래스 추가 완료");
              
              // 전체 선택 체크박스도 비활성화
              const selectAllCheckbox = document.querySelector('.select-all-container input[type="checkbox"]');
              if (selectAllCheckbox) {
                selectAllCheckbox.disabled = true;
                console.log("watch에서 전체 선택 체크박스 비활성화 완료");
              }
            }
          });
        }
        
        // 다음 틱에서 플래그 해제
        this.$nextTick(() => {
          this._preventWatchLoop = false;
          console.log("preventWatchLoop 플래그 해제");
        });
        
        console.log("=== supplierBurden watch 완료 ===");
      },
      immediate: true // 즉시 실행하여 watch 등록 확인
    },
    
    // 할인 항목 배열 변경 감지
    'settings.discountItems': {
      handler(newItems, oldItems) {
        console.log("=== discountItems watch 시작 ===");
        console.log("변경된 항목:", newItems);
        console.log("preventWatchLoop 상태:", this._preventWatchLoop);
        
        // 무한루프 방지 - 프로그래밍적 변경은 무시
        if (this._preventWatchLoop) {
          console.log("프로그래밍적 변경 감지 - watch 무시");
          return;
        }
        
        console.log("사용자 액션으로 인한 할인 항목 변경 처리");
        
        // 무한루프 방지 플래그 설정
        this._preventWatchLoop = true;
        
        // 할인 항목이 없으면 공급사 부담도 해제하고 레이어 닫기
        if (newItems.length === 0) {
          console.log("모든 항목 해제 - 공급사 부담 자동 해제");
          this.settings.supplierBurden = false;
          this.showDiscountItems = false;
        } else {
          // 하나라도 항목이 있으면 레이어 열기 (supplierBurden은 이미 true일 것임)
          console.log("항목 있음 - 레이어 열기");
          this.showDiscountItems = true;
        }
        
        // 다음 틱에서 플래그 해제
        this.$nextTick(() => {
          this._preventWatchLoop = false;
          console.log("preventWatchLoop 플래그 해제");
        });
        
        console.log("=== discountItems watch 완료 ===");
      },
      deep: true
    }
  },
  computed: {
    ...mapState("common", ["mall_id"]),
     isExcelTemplateAllowed() {
      // Common.js의 isExcelTemplateAllowed 함수를 사용하여 체크
      return Common.isExcelTemplateAllowed(this.mall_id);
    },
    isDiscountTimingAllowed() {
      const allowedMallIds = ['surping1','supplyqa', 'cafe24plusapp2'];
      return allowedMallIds.includes(this.mall_id);
    },
    // 할인 항목들이 모두 선택되었는지 확인
    allDiscountItemsSelected() {
      return this.settings.discountItems.length === 3 && 
             this.settings.discountItems.includes("benefit") && 
             this.settings.discountItems.includes("coupon") && 
             this.settings.discountItems.includes("discount_code");
    },
    
    // 전체 선택 상태 (모든 할인 항목이 선택되었는지 확인)
    isAllSelected() {
      return this.settings.discountItems.length === 3 && 
             this.settings.discountItems.includes("benefit") && 
             this.settings.discountItems.includes("coupon") && 
             this.settings.discountItems.includes("discount_code");
    },
    
    // selectbox 하단 radius 스타일
    border_bottom_radius_style() {
      return this.showDiscountItems ? 'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' : '';
    }
  },
  methods: {
    ...mapActions("supply", ["getSupplySettings", "saveSupplySettings"]),
      // 설정 저장
    async saveSetting() {      

      try {
        const settingData = {
          settlement_timing: this.settings.settlementTiming,
          discount_apply_timing: this.settings.discountApplyTiming,
          discount_items: this.settings.discountItems
        };
        
        await this.saveSupplySettings(settingData);
        
        // 원본 설정값 업데이트
        this.originalSettings = JSON.parse(JSON.stringify(this.settings));
        
        alert("설정이 저장되었습니다.");
      } catch (error) {
        console.error("설정 저장 중 오류가 발생했습니다:", error);
        alert("설정 저장 중 오류가 발생했습니다.");
      }
    },    // 설정 취소 (원래 값으로 복원)
    resetSetting() {
      this.settings = JSON.parse(JSON.stringify(this.originalSettings));
      // 복원된 설정에 따라 레이어 상태도 업데이ㅓ
      this.showDiscountItems = this.settings.discountItems.length > 0;
    },    // 공급사 부담 체크박스 클릭 처리 (디버깅용)
    handleSupplierBurdenClick(event) {
      console.log("=== 공급사 부담 체크박스 직접 클릭 ===");
      console.log("클릭된 체크박스 상태:", event.target.checked);
      console.log("현재 v-model 값:", this.settings.supplierBurden);
      console.log("preventWatchLoop 상태:", this._preventWatchLoop);
      
      // custom_select_box 요소 찾기 (여러 방법 시도)
      let selectBox = document.querySelector('.custom_select_box');
      
      // ref를 통한 접근도 시도
      if (!selectBox && this.$refs.discountItemsArea) {
        selectBox = this.$refs.discountItemsArea.querySelector('.custom_select_box');
      }
      
      if (event.target.checked) {
        // 공급사 부담 체크 시 레이어의 disabled 클래스 제거
        console.log("공급사 부담 체크 - custom_select_box disabled 클래스 제거");
        if (selectBox) {
          selectBox.classList.remove('disabled');
          console.log("disabled 클래스 제거 완료. 현재 클래스:", selectBox.className);
        } else {
          console.log("custom_select_box 요소를 찾을 수 없음");
          // 모든 .custom_select_box 요소 찾아보기
          const allSelectBoxes = document.querySelectorAll('.custom_select_box');
          console.log("페이지 내 custom_select_box 요소 개수:", allSelectBoxes.length);
        }
        
        // 할인 항목 설정 및 레이어 열기
        this.settings.discountItems = ["benefit", "coupon", "discount_code"];
        this.showDiscountItems = true;
        
        // 전체 선택 체크박스 활성화 (즉시 적용)
        this.$nextTick(() => {
          const selectAllCheckbox = selectBox?.querySelector('input[type="checkbox"]');
          if (selectAllCheckbox) {
            selectAllCheckbox.disabled = false;
            console.log("전체 선택 체크박스 활성화 완료");
          }
          
          // 다른 방법으로도 시도 (클래스 선택자 사용)
          const selectAllByClass = document.querySelector('.select-all-container input[type="checkbox"]');
          if (selectAllByClass) {
            selectAllByClass.disabled = false;
            console.log("클래스 선택자로 전체 선택 체크박스 활성화 완료");
          }
        });
      } else {
        // 할인 항목 해제 및 레이어 닫기
        this.settings.discountItems = [];
        this.showDiscountItems = false;
        
        // 공급사 부담 해제 시 레이어의 disabled 클래스 추가
        console.log("공급사 부담 해제 - custom_select_box disabled 클래스 추가");
        if (selectBox) {
          selectBox.classList.add('disabled');
          console.log("disabled 클래스 추가 완료. 현재 클래스:", selectBox.className);
          
          // 전체 선택 체크박스 비활성화
          this.$nextTick(() => {
            const selectAllCheckbox = selectBox?.querySelector('input[type="checkbox"]');
            if (selectAllCheckbox) {
              selectAllCheckbox.disabled = true;
              console.log("전체 선택 체크박스 비활성화 완료");
            }
            
            // 다른 방법으로도 시도 (클래스 선택자 사용)
            const selectAllByClass = document.querySelector('.select-all-container input[type="checkbox"]');
            if (selectAllByClass) {
              selectAllByClass.disabled = true;
              console.log("클래스 선택자로 전체 선택 체크박스 비활성화 완료");
            }
          });
        } else {
          console.log("custom_select_box 요소를 찾을 수 없음");
        }
      }
      
      // v-model이 자동으로 값을 업데이트하므로 수동 처리는 하지 않음
      // 단지 로그만 찍어서 클릭 이벤트가 발생하는지 확인
    },
    
    // 전체 선택 체크박스 클릭 처리
    handleSelectAllClick(event) {
      // 이벤트 전파 방지
      event.stopPropagation();
      
      console.log("전체 선택 체크박스 클릭:", event.target.checked);
      
      if (event.target.checked) {
        // 전체 선택 시 모든 항목 선택
        console.log("전체 선택 - 모든 항목 선택");
        this.settings.discountItems = ["benefit", "coupon", "discount_code"];
      } else {
        // 전체 선택 해제 시 모든 항목 해제
        console.log("전체 선택 해제 - 모든 항목 해제");
        this.settings.discountItems = [];
      }
    },
    
    // 전체 선택 토글 (기존 메서드 유지)
    toggleSelectAll() {
      console.log("toggleSelectAll 호출, 현재 allDiscountItemsSelected:", this.allDiscountItemsSelected);
      
      if (this.isAllSelected) {
        // 전체 선택 해제 시 모든 항목 해제
        this.settings.discountItems = [];
      } else {
        // 전체 선택 시 모든 항목 선택
        this.settings.discountItems = ["benefit", "coupon", "discount_code"];
      }
    },
    
    // 텍스트 클릭 시 펼침/접힘 
    toggleDiscountItemsDisplay() {
      if (!this.settings.supplierBurden) return;
      this.showDiscountItems = !this.showDiscountItems;
    },
    
    // 외부 클릭 시 할인 항목 영역 닫기
    handleClickOutside(event) {
      // 할인 항목 영역이 열려있을 때만 처리
      if (!this.showDiscountItems) return;
      
      // 클릭된 요소가 할인 항목 영역 내부인지 확인
      const discountItemsArea = this.$refs.discountItemsArea;
      if (discountItemsArea && !discountItemsArea.contains(event.target)) {
        this.showDiscountItems = false;
      }
    },
    
    // 개별 할인 항목 토글
    toggleDiscountItem(itemValue) {
      if (!this.isEditable || !this.settings.supplierBurden) return;
      
      const index = this.settings.discountItems.indexOf(itemValue);
      if (index > -1) {
        // 항목이 있으면 제거
        this.settings.discountItems.splice(index, 1);
      } else {
        // 항목이 없으면 추가
        this.settings.discountItems.push(itemValue);
      }
    },
    
    // 개별 항목이 선택되어 있는지 확인
    isItemSelected(itemValue) {
      return this.settings.discountItems.includes(itemValue);
    },
    
    // 설정 불러오기
    async loadSettings() {
      try {
        console.log("=== 설정 불러오기 시작 ===");
        const response = await this.getSupplySettings();
        if (response) {
          console.log("설정 불러오기 응답:", response);
          
          // watch 트리거 방지
          console.log("watch 방지 플래그 설정");
          this._preventWatchLoop = true;
          
          this.settings = {
            settlementTiming: response.settlement_timing || 'delivery_completed',
            discountApplyTiming: response.discount_apply_timing || 'now',
            discountItems: response.discount_items || []
          };

          // 원본 설정값 저장
          this.originalSettings = JSON.parse(JSON.stringify(this.settings));
          
          // 초기 상태 설정
          this.settings.supplierBurden = this.settings.discountItems.length > 0;
         // this.showDiscountItems = this.settings.discountItems.length > 0;
          
          console.log("초기 설정 완료:", {
            supplierBurden: this.settings.supplierBurden,
            discountItemsLength: this.settings.discountItems.length,
            discountItems: this.settings.discountItems,
            showDiscountItems: this.showDiscountItems
          });
          
          // watch 활성화
          this.$nextTick(() => {
            this._preventWatchLoop = false;
            console.log("watch 방지 플래그 해제 - 정상 작동 시작");
            console.log("=== 설정 불러오기 완료 ===");
          });
        }
      } catch (error) {
        console.error("설정 불러오기 중 오류가 발생했습니다:", error);
      }
    }
  },
  
  async created() {
    await this.loadSettings();
  },
  
  mounted() {
    console.log("=== Setting 컴포넌트 mounted ===");
    console.log("현재 settings:", this.settings);
    console.log("supplierBurden 값:", this.settings.supplierBurden);
    
    // 프로그래밍적으로 watch 등록 (백업용)
    this.$watch('settings.supplierBurden', (newVal, oldVal) => {
      console.log("=== $watch로 감지된 supplierBurden 변경 ===");
      console.log("새 값:", newVal, "이전 값:", oldVal);
    }, { immediate: true });
    
    // 외부 클릭 이벤트 리스너 추가
    document.addEventListener('click', this.handleClickOutside);
    
    // 5초 후 테스트용 로그
    setTimeout(() => {
      console.log("5초 후 상태 확인:");
      console.log("supplierBurden:", this.settings.supplierBurden);
      console.log("discountItems:", this.settings.discountItems);
    }, 5000);
  },
  
  beforeDestroy() {
    // 외부 클릭 이벤트 리스너 제거
    document.removeEventListener('click', this.handleClickOutside);
  },
};
